import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  count: number
  integrationLabel: string
}

const SupplementsToSync = ({ count, integrationLabel }: Props) => {
  if (!(count > 0)) return null

  return (
    <Box
      paddingTop="s16"
      flexDirection="row"
      background="champagne400"
      borderRadius={{
        all: 'abs008',
      }}
      width="full"
      paddingX="s24"
      paddingY="s16"
      gap="s8"
    >
      <Icon.Medium icon="link" color="grey800" />
      <Text.Normal size="200" weight="medium">
        {i18n.tp('payroll_integrations.kombo.supplements_preview.to_sync', {
          count: count,
          integrationLabel: integrationLabel,
        })}
      </Text.Normal>
    </Box>
  )
}

export default SupplementsToSync
